export class CalendarEventTemplateRole {
    //netgen start
    eventTemplateId = 0;
    roleId = 0;
    count = 0;
    id = 0;
    //netgen end
}
